import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [loading, setLoading] = useState(true);

  const loadUser = async () => {
    const token = localStorage.getItem("sj_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("sj_token");
      setUser(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadUser();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerClient = async (payload) => {
    const { data } = await api.post("/auth/register/client", payload);
    localStorage.setItem("sj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerContractor = async (payload) => {
    const { data } = await api.post("/auth/register/contractor", payload);
    localStorage.setItem("sj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = async (token) => {
    localStorage.setItem("sj_token", token);
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("sj_token");
    setUser(false);
  };

  const isViewer = !!user && user.role === "client" && user.org_role === "viewer";

  return (
    <AuthContext.Provider value={{ user, loading, isViewer, login, loginWithToken, registerClient, registerContractor, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function dashboardPath(role) {
  return { client: "/app/client", contractor: "/app/contractor", dispatcher: "/app/dispatch", admin: "/app/admin", tenant: "/app/tenant" }[role] || "/";
}
